import { useEffect, useState } from 'react';

import routes from './routes';
import httpClient, { isHttpError } from '../httpClient';

export async function getAllProaqs() {
  try {
    const response = await httpClient.get(routes.proaq);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao obter lista de Proaqs.',
      );
    }
    throw error;
  }
}

export async function getProaqsByUsuario() {
  try {
    const response = await httpClient.get(`/api/proaq/proaqs-por-usuario`);
    console.log('Proaqs do usuário: ', response);

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter ARPs do usuário: ' + error);
  }
}

export async function getProaq(proaqID: string) {
  try {
    const response = await httpClient.get(`${routes.proaq}/${proaqID}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Proaq: ' + error);
  }
}

interface ProaqOption {
  id: number;
  numeroProaq: string;
}

export const useProaqPorComponente = (componente: string | null) => {
  const [registroEnum, setRegistroEnum] = useState<ProaqOption[]>([]);

  useEffect(() => {
    if (!componente) return; // Não faz a chamada se o componente não for válido

    const fetchRegistroEnum = async () => {
      try {
        const response = await httpClient.get(
          `/api/proaq/proaqs-por-componente/${componente}`,
        );

        const options = response.data.map(
          (registro: { id: number; numeroProaq: string }): ProaqOption => ({
            id: registro.id,
            numeroProaq: registro.numeroProaq,
          }),
        );
        setRegistroEnum(options);
      } catch (error) {
        console.error('Erro ao buscar dados.', error);
      }
    };

    fetchRegistroEnum();
  }, [componente]); // Atualiza os dados quando o componente muda

  return registroEnum;
};

export async function getProaqPorProdutoId(id: string) {
  try {
    const response = await httpClient.get(`/api/proaq/produtodaf/${id}`);

    return response.data;
  } catch (error) {
    throw new Error(
      'Erro ao obter Proaqs relacionados ao Produto DAF: ' + error,
    );
  }
}

export async function getProaqPorDenominacaoId(id: string) {
  try {
    const response = await httpClient.get(`/api/proaq/denominacao/${id}`);

    return response.data;
  } catch (error) {
    throw new Error(
      'Erro ao obter Proaqs relacionados à Denominação Genérica: ' + error,
    );
  }
}

export async function getProaqPorKitId(id: string) {
  try {
    const response = await httpClient.get(`/api/proaq/kitproduto/${id}`);

    return response.data;
  } catch (error) {
    throw new Error(
      'Erro ao obter Proaqs relacionados ao Kit de Produtos: ' + error,
    );
  }
}

export async function getProaqPorFluxoProaqId(id: string) {
  try {
    const response = await httpClient.get(`/api/proaq/fluxoproaq/${id}`);

    return response.data;
  } catch (error) {
    throw new Error(
      'Erro ao obter Proaqs relacionados ao Fluxo Proaq (modelo): ' + error,
    );
  }
}

export async function getAllTipoModalidade() {
  try {
    const response = await httpClient.get(routes.tipomodalidade);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Tipos de Modalidade: ' + error);
  }
}

export async function getTipoModalidade(tipoModalidadeID: string) {
  try {
    const response = await httpClient.get(
      `${routes.tipomodalidade}/${tipoModalidadeID}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Tipo de Modalidade: ' + error);
  }
}

export async function getAllSubtipoModalidade() {
  try {
    const response = await httpClient.get(routes.subtipomodalidade);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Subtipos de Modalidade: ' + error);
  }
}

export async function getAllSubtipoModalidadeByTipoModalidade(
  tipoModalidadeId: number,
) {
  try {
    const response = await httpClient.get(
      `/api/subtipomodalidade/tipomodalidade/${tipoModalidadeId}`,
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Subtipos de Modalidade: ' + error);
  }
}

export async function getSubtipoModalidade(subtipoModalidadeID: string) {
  try {
    const response = await httpClient.get(
      `${routes.subtipomodalidade}/${subtipoModalidadeID}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Subtipo de Modalidade: ' + error);
  }
}

export const updateProaq = async (id: string, data: any) => {
  try {
    const response = await httpClient.patch(`${routes.proaq}/${id}`, data);
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao atualizar o PROAQ.',
      );
    }
    throw error;
  }
};

export const deleteProaq = async (id: string) => {
  try {
    const response = await httpClient.delete(`${routes.proaq}/${id}`);
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao deletar o PROAQ.',
      );
    }
    throw error;
  }
};

export const createProaq = async (data: any): Promise<any> => {
  try {
    const response = await httpClient.post(routes.proaq, data);
    return response.data;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao criar o PROAQ.',
      );
    }
    throw error;
  }
};
